import { default_language } from 'app/config/constants'
import en from 'i18n/en.json'
import ru from 'i18n/ru.json'
import i18next, { t } from 'i18next'
import { isValidElement, ReactElement } from 'react'
import { Trans } from 'react-i18next'
import { opt } from 'store/opt'
import { capitalize } from 'util/string'

type RawOptions = Record<string, string | number | ReactElement | undefined>
type RawTextOptions = Record<string, string | number | undefined>

type Options = {
  values: Record<string, string | number>
  components: Record<string, ReactElement>
}

function parseOptions(raw: RawOptions | undefined): Options {
  const options: Options = {
    values: {},
    components: {},
  }
  for (const [key, value] of Object.entries(raw ?? {})) {
    if (isValidElement(value)) {
      options.components[key] = value as ReactElement
    } else if (typeof value === 'string') {
      options.values[key] = value
    } else if (typeof value === 'number') {
      options.values[key] = value
    } else if (value == null) {
      // skip
    } else if (value) {
      options.values[key] = value.toString()
    }
  }
  return options
}

export type I18nKey = keyof typeof en

export function fix(text: string): string {
  if (opt.upper) return text
  const up = text.split('').every(c => c === c.toUpperCase())
  return up ? capitalize(text) : text
}

export function i18n(key: I18nKey): string;
export function i18n(key: I18nKey, options?: RawTextOptions): string;
export function i18n(key: I18nKey, options?: RawOptions): string | ReactElement;
export function i18n(key: I18nKey, options?: RawOptions): string | ReactElement {
  const lang = i18next.resolvedLanguage || default_language
  const init = i18next.isInitialized
  const defaultValue = lang === 'en' ? en[key] : ru[key]

  const { values, components } = parseOptions(options)
  const simple = Object.keys(components).length === 0

  if (!init) return defaultValue
  if (simple) return fix(t(key, { ...values, defaultValue }))

  // @ts-ignore
  return <Trans i18nKey={key} values={values} components={components} defaults={defaultValue} />
}
